module.exports = __webpack_public_path__ + "media/assets/img/faces/yizeng-1d9e01614291dd26070070881dcc476a.jpg";